import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-u-shaped',
  templateUrl: './curtain-u-shaped.component.html',
  styleUrls: ['./curtain-u-shaped.component.scss']
})
export class CurtainUShapedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
